<template>
    <component :is="listItemComponent" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import LectureListItemLegacy from '@/components/custom/lecture-list-item'
import LectureListItemUnified from './unified/lecture-list-item'
import GlobalComputed from '@/helpers/global-computed'

export default {
    computed: {
        ...GlobalComputed,
        listItemComponent(){
            return this.appData && this.appData.lectures_view_layout === 'legacy'
                ? LectureListItemLegacy
                : LectureListItemUnified;
        },
    },
}
</script>
